import { observable, action, flow, runInAction, computed, toJS } from 'mobx';
import { Toast, Modal } from 'antd-mobile';
import utils from 'utils';
import { get } from 'lodash';
import { rstr2b64, hex_md5, Encrypts } from 'utils/md5';
import Config from 'config/Config';
import Stores from 'config/Stores';
import TimMobx from 'pages/TIM/Common/tim';
import Serv from './LoginServ';
import { t } from 'config/language/context';

class LoginMod {
  // 会员登录图片验证码：url、输入的验证码、验证码的uniqueId
  @observable memberGraphUrl = '';

  @observable memberGraphCode = '';

  @observable memberGraphUniqueId = '';

  // 店铺登录图片验证码：url、输入的验证码、验证码的uniqueId
  @observable storeGraphUrl = '';

  @observable storeGraphCode = '';

  @observable storeGraphUniqueId = '';

  @observable loginBackType = ''; // // 登录时返回使用,back返回

  // 会员卡登录
  @observable memberNum =
    sessionStorage.getItem('systemCode') == 'LY'
      ? localStorage.getItem('remberPwdForAccNum') == 'null'
        ? ''
        : localStorage.getItem('remberPwdForAccNum')
      : '';

  @observable memberPwd = '';

  @observable LYmemberPwd = '';

  @observable LYtempPwd = ''; // 临时解码密码

  // 手机号登录
  @observable phone = '';

  // 老鹰🦅手机号登录
  @observable LYphone =
    sessionStorage.getItem('systemCode') == 'LY'
      ? localStorage.getItem('remberPwdForPhoNum') == 'null'
        ? ''
        : localStorage.getItem('remberPwdForPhoNum')
      : '';

  @observable memberNum_2 = '';

  // 老鹰🦅
  @observable LYmemberNum_3 = '';

  // 店铺登录
  // 0 - 店长登录， 1 - 子账号登录
  @observable storeLoginTarget = 0;

  @observable storeNum = '';

  @observable storePwd = '';

  // 用户真实姓名
  @observable realName = '';

  // 身份证号
  @observable idCard = '';

  // 和phone不同，这个是与会员卡绑定的手机号（后台数据库的），phone只是记住用户在input输入值
  @observable bindPhone = '';

  // 当前手机号绑定的会员数量 + 1，即绑定1张卡，该值为2
  @observable userCount = 1;

  @observable LYuserCount = 1;

  // 把传递过来的密码转换成星号
  @observable memberPwdStar = '';

  // 登录页密码
  @observable storePwdStar = '';

  // 登录页密码
  @observable originPasswordStar = '';

  // 修改页密码
  @observable oldPasswordStar = '';

  // 修改页密码
  @observable passwordStar = '';

  // 修改页密码
  @observable passwordAgainStar = '';

  // 修改页密码
  // 注册时绑定健康顾问信息
  @observable cardInfoState = {};

  // 多卡号选择弹窗数据
  @observable memberCardsVisible = false;

  @observable memberCardList = [];

  /**
   * 修改参数逻辑
   */
  @action
  changeState(key, value) {
    console.log('key111', key, value);
    this[key] = value;
    if (key == 'memberPwd' || key == 'storePwd') {
      this.changeStar(value, key);
    }
  }

  // 把传递过来的数据转换成星号方法
  changeStar(value, key) {
    let starData = {
      memberPwd: 'memberPwdStar',
      storePwd: 'storePwdStar'
    };
    // 判断内容是否为空
    if (!value) {
      this[starData[key]] = '';
      return;
    }
    // 遍历数据的长度并把它变成*号
    let str = '';
    let length = value.length;
    for (let i = 0; i < length; i++) {
      str += '*';
    }
    this[key] = str;
    // 当输入款删除内容的时候，要修改传给后台的不是*号的数据
    if (length <= this[starData[key]].length) {
      this[starData[key]] = this[starData[key]].substr(0, length);
      return;
    }
    if ((key == 'memberPwd' || key == 'storePwd') && value) {
      // 密码本身可能带有* 号
      const result = value.trim().split('');
      this[starData[key]] += result[result.length - 1];
    } else {
      this[starData[key]] += value.replace(/\*/gi, '');
    }
  }

  /**
   * 清除所有状态
   */
  @action
  clear() {
    this.memberNum = '';
    this.memberPwd = '';
    this.memberPwdStar = '';
    this.storePwdStar = '';
    this.phone = '';
    this.memberNum_2 = '';
    this.storeNum = '';
    this.storePwd = '';
    this.realName = '';
    this.idCard = '';
    this.bindPhone = '';
    this.userCount = 1;
    this.memberGraphUrl = '';
    this.memberGraphCode = '';
    this.memberGraphUniqueId = '';
    this.storeGraphUrl = '';
    this.storeGraphCode = '';
    this.storeGraphUniqueId = '';
    this.LYtempPwd = '';
    // this.loginBackType = ''

    TimMobx.destroy();
  }

  /**
   * 获取手机验证码
   */
  getVerifyCode = flow(
    function* (descriptionType, phone, memberNum, isRetAll, exObj, verifyCodeData) {
      const { imageCode } = exObj || {};

      const timestamp = new Date().getTime();
      try {
        let params = {
          cardCode: memberNum || Stores.AppMod.userInfo.cardCode || '',
          phone: phone || this.phone,
          descriptionType, // 1 - 注册，2 - 登录，3 - 找回密码，4 - 绑定手机
          codeType: 2, // 1 - 图像验证码，2 - 手机验证码，3 - 邮箱验证码
          md5Sign: encodeURIComponent(
            Encrypts(
              `${timestamp}#${hex_md5(
                (phone || this.phone).replace(/\s*/g, '') + utils.getSendMsgParamsUat()
              ).toUpperCase()}`
            )
          ),
          areaCode: Stores.AppMod.areaCode
        };
        imageCode && (params.imageCode = imageCode);
        let data = {};
        let resultMsg = '';
        if (verifyCodeData) {
          data = verifyCodeData.data;
          resultMsg = verifyCodeData.resultMsg;
        } else {
          const res = yield Serv.getVerifyCode(params);
          data = res.data;
          resultMsg = res.resultMsg;
        }
        // const {data, resultMsg, resultCode} = yield Serv.getVerifyCode(params);
        // 获取验证码超过三次则显示系统二维码 调用
        // if (+resultCode === 3333 && params.phone) {
        // this.getCaptcha(params.phone);
        // return resultCode;
        // }
        if (isRetAll) {
          return data || {};
        }

        if (data && data.uniqueId) {
          !verifyCodeData && Toast.info(resultMsg, 2);
          this.userCount = data.userCount;
          // 新客注册
          if (data.userCount == 0) {
            const { cardCode } = Stores.AppMod.isCardCode;
            const healthyMember = utils.getQueryString('memberNum');
            const shareCardCode = utils.getLocalCache(Config.localStorageKeys.share_card_code);
            const memberNum = utils.getLocalCache('memberNum');
            const sessionCode = sessionStorage.getItem('memberNum');
            const memberCard = cardCode || shareCardCode || sessionCode || memberNum;
            const bindCardCode =
              utils.getQueryString('shareCardCode') ||
              utils.getQueryString('bindCardCode') ||
              Stores.AppMod.bindCardCode.cardCode ||
              Stores.AppMod.isCardCode.cardCode ||
              utils.getLocalCache('bindCardCode') ||
              '';
            Stores.RegisterMod.getCardCodeInfo({
              cardCode: bindCardCode || memberCard || healthyMember || '8888888888',
              register: true
            }).then((data) => {
              runInAction(() => {
                this.cardInfoState = data;
                const { needRegisterOrder, permitVirtualCard, code } = data;
                // 注册及开卡
                if (
                  code == 'LY' ||
                  sessionStorage.getItem('systemCode') == 'LY' ||
                  (needRegisterOrder == 0 && code !== 'KER')
                ) {
                  Stores.RegisterMod.changeState('isApply', false);
                  Stores.RegisterMod.changeState('allowRquest', true);
                  Stores.RegisterMod.changeState('phone', phone || this.phone);
                  Stores.RegisterMod.changeState('needRegisterOrder', needRegisterOrder);
                  Stores.RegisterMod.changeState(
                    'consultant',
                    bindCardCode || memberCard || healthyMember || '8888888888'
                  );
                  // 注册时开卡
                } else if (!!permitVirtualCard && needRegisterOrder !== 0) {
                  Stores.RegisterMod.changeState('isApply', true);
                  Stores.RegisterMod.changeState('allowRquest', true);
                  Stores.RegisterMod.changeState('phone', phone || this.phone);
                  Stores.RegisterMod.changeState('needRegisterOrder', needRegisterOrder);
                  Stores.RegisterMod.changeState(
                    'consultant',
                    bindCardCode || memberCard || healthyMember || '8888888888'
                  );
                } else {
                  Stores.RegisterMod.changeState('isApply', false);
                  Stores.RegisterMod.changeState('allowRquest', true);
                  Stores.RegisterMod.changeState('phone', phone || this.phone);
                  Stores.RegisterMod.changeState('needRegisterOrder', needRegisterOrder);
                  Stores.RegisterMod.changeState(
                    'consultant',
                    bindCardCode || memberCard || healthyMember || '8888888888'
                  );
                }
              });
            });
          }
          return data.uniqueId;
        }
        return null;
      } catch (error) {
        console.log('error.>>>>>', error);
        return null;
      }
    }
  );

  /**
   * 获取会员登录图形验证码
   */
  getMemberGraphCode = flow(function* () {
    try {
      const { data } = yield Serv.getMemberGraphCode();
      this.memberGraphUrl = `data:image/png;base64,${data.image}`;
      this.memberGraphUniqueId = data.uniqueId;
    } catch (error) {}
  });

  /**
   * 获取店铺登录图形验证码
   */
  getStoreGraphCode = flow(function* () {
    try {
      const { data } = yield Serv.getStoreGraphCode();
      this.storeGraphUrl = `data:image/png;base64,${data.image}`;
      this.storeGraphUniqueId = data.uniqueId;
    } catch (error) {}
  });

  /**
   * 会员卡登录
   */
  loginByMember = flow(async function* (exObj) {
    const { inletTitle = '' } = exObj || {};
    try {
      if (this.memberGraphUrl && !this.memberGraphCode) {
        Toast.info(t('请先输入图形验证码'));
        return;
      }
      const { memberNum, memberPwd, memberPwdStar } = this;
      let params = {
        cardCode: utils.clearSpaces(this.memberNum),
        password: this.LYtempPwd ? rstr2b64(this.LYtempPwd) : rstr2b64(this.memberPwdStar),
        loginType: 1,
        type: 1,
        userDomain: Config.wxAppId || '',
        ...(sessionStorage.getItem('systemCode') == 'LY'
          ? {
              rememberPasswordTag: localStorage.getItem('isRemberPwdForAcc') ? 1 : 0,
              userOpenId: localStorage.getItem('openIdLYRemPwd')
            }
          : {})
      };
      if (
        utils.isXM() &&
        !!sessionStorage.getItem('xm_openId') &&
        !!sessionStorage.getItem('xm_accessToken')
      ) {
        // 享脉参数
        params.openId = sessionStorage.getItem('xm_openId');
        params.accessToken = sessionStorage.getItem('xm_accessToken');
      }

      // 输错密码次数过多，需要图片验证码
      if (this.memberGraphUrl) {
        Object.assign(params, {
          code: this.memberGraphCode,
          uniqueId: this.memberGraphUniqueId,
          codeType: 1
        });
      }
      const { data, resultCode, resultMsg } = yield Serv.loginByMember(params);
      sessionStorage.getItem('systemCode') == 'LY' &&
        localStorage.setItem('remberPwdForAccNum', params.cardCode);
      if (resultCode != 0) {
        Toast.fail(resultMsg, 2);
        if ((data && data.imgVerifyFlag) || this.memberGraphUrl) {
          this.getMemberGraphCode();
        }
        return;
      }

      if (!!Stores.AppMod.dojumpData && Stores.AppMod.dojumpData.id) {
        window.sensors.track('doJump', {
          id: Stores.AppMod.dojumpData.id,
          backLogin: true,
          userId: data.userId
        });
      }

      const tempNum = memberNum;
      const tempPwd = memberPwdStar;
      let isReLogin = false; // 是否和上一次登录的是同一个账号
      let backSpecialPageUrl = utils.getLocalCache('backSpecialPageUrl'); // 是否返回上一个页面的标识
      let decoratorBackHref = localStorage.getItem('decoratorBackHref');
      let loginGoback = utils.getLocalCache(Config.localStorageKeys.loginGoback); // 是否返回上一个页面的标识
      const registerRoute = utils.getLocalCache(Config.localStorageKeys.registerRoute); // 返回上一页的地址
      // 用户可能在登录状态下，重新登录，所以及时清除掉以前的用户本地数据 及 应用LoginMod数据也要清除
      // LY登录
      const lyCode = sessionStorage.getItem('systemCode');
      let cacheObj = {};
      if (lyCode == 'LY') {
        cacheObj = utils.getKeysLocalCache([
          'remberPwdForAccNum',
          'isRemberPwdForAcc',
          'remberPwdForPhoNum',
          'isRemberPwdForPho'
        ]);
      }
      Stores.AppMod.clearData();
      Stores.LoginMod.clear();

      lyCode && utils.setKeysLocalCache(cacheObj);
      lyCode && sessionStorage.setItem('systemCode', lyCode);
      lyCode && sessionStorage.setItem('LYFlag', 'true');
      // 登录成功，将该登录账号记录到本地（最近登录的6个账号）
      let list = JSON.parse(
        utils.getLocalCache(Config.localStorageKeys.member_recentSixNum) || '[]'
      );
      isReLogin = memberNum == list[0];
      let _index = list.indexOf(memberNum);
      if (_index != -1) {
        list.splice(_index, 1);
      }
      if (list.length == 6) {
        list.pop();
      }
      list.unshift(memberNum);
      utils.setLocalCache(Config.localStorageKeys.member_recentSixNum, JSON.stringify(list));
      // 暂存用户姓名
      this.realName = data.realName;
      // 如果会员还未绑定手机号，立即跳转绑定手机号
      if (data.bindPhoneFlag) {
        window.app.routerGoTo({
          pathname: '/personal/account/bind/memberToPhoneByCard',
          state: {
            realName: data.realName,
            bindMemberNum: tempNum,
            hadEncodeMemberPwd: rstr2b64(tempPwd)
          }
        });
        return;
      }
      console.log('data.realName >> ', data.realName);
      // 用户一百天未登录，跳转验证身份
      if (data.phoneVerifyFlag) {
        window.app.routerGoTo({
          pathname: '/personal/account/phoneVerify',
          state: {
            memberNum,
            realName: data.realName,
            hadEncodeMemberPwd: rstr2b64(memberPwdStar),
            bindPhone: data.phone,
            areaCode: data.areaCode
          }
        });
        return;
      }

      // 存储会员信息
      Stores.AppMod.saveLoginInfo(data).then(async () => {
        const { userInfo } = Stores.AppMod;
        const {
          cardAttribute,
          cardPwdStatus,
          memberStatus,
          belongSystem,
          contractSign,
          id,
          realName,
          phone
        } = userInfo || {};
        utils.setLocalCache('wechat_share_back', true);

        // 老鹰站点跳转提示页
        let checkTips = await Stores.AppMod.getCheckDomainTips(belongSystem);
        if (!checkTips) return;

        if (belongSystem == 'KER') {
          Stores.AppMod.setKerUpdateHealth(); // 可儿玫瑰更新健康顾问
        }

        // if((belongSystem == 'LD' || belongSystem == 'DD') && !contractSign){
        //   //登录成功，记录下是否是弱密码！！！
        //   if (memberPwdStar == '123456') {
        //     localStorage.setItem('isWeakPwd', 1);
        //   }
        //   return
        // }
        // 登录成功，记录下是否是弱密码！！！
        if (memberPwdStar == '123456') {
          localStorage.setItem('isWeakPwd', 1);
          window.app.routerGoTo('personal/account/alterPassword');
          return;
        }
        // Stores.AppMod.setImLogin({
        //   userId: userInfo.id
        // })

        // 课程分享跳转逻辑
        const { targetUrlShare } = Object.fromEntries(
          new URLSearchParams(window.location.href.split('?')[1])
        );
        if (targetUrlShare) {
          let tmpUrl = window.location.href.split('?')[1];
          tmpUrl = tmpUrl.split('=')[1];
          if (targetUrlShare && tmpUrl) {
            window.location.href = `${tmpUrl}?${window.location.href.split('?')[2]}`;
            return;
          }
        }
        if (decoratorBackHref && !['null', 'undefined'].includes(decoratorBackHref)) {
          // 线下活动详情
          if (decoratorBackHref.includes('/promote/offlineActivity/activityDetail')) {
            Stores.AppMod.meetValidate(decoratorBackHref.split('id=')[1]).then((data) => {
              if (data) {
                window.app.routerRedirect(decoratorBackHref);
              } else {
                window.app.routerRedirect('/');
              }
            });
            return;
          }
          window.location.href = decoratorBackHref;
          return;
        }
        if (backSpecialPageUrl) {
          window.location.href = backSpecialPageUrl;
          return;
        }
        // 是否需要提示修改密码
        // if (cardAttribute == '0' && cardPwdStatus == 1 && memberStatus == '0') {
        //   Modal.alert(
        //     '温馨提示',
        //     '为了您的账户信息安全，请修改您的登录密码！',
        //     [
        //       {
        //         text: '取消',
        //         onPress: () => window.app.routerGoTo('/shop/home'),
        //       },
        //       {
        //         text: '确定',
        //         onPress: () =>
        //           window.app.routerRedirect('/personal/account/alterPassword'),
        //       },
        //     ],
        //   );
        //   return;
        // }

        console.log('this.loginBackType', toJS(userInfo));

        if (loginGoback) {
          utils.setLocalCache(Config.localStorageKeys.registerRoute, '');
          utils.setLocalCache(Config.localStorageKeys.loginGoback, '');
          if (registerRoute) {
            const id = utils.getParamsQueryString(registerRoute, 'offlineActivityId');
            // 线下活动
            if (registerRoute.includes('/promote/offlineActivity/activityDetail' && id)) {
              Stores.AppMod.meetValidate(id).then((data) => {
                if (data) {
                  window.app.routerRedirect(`/promote/offlineActivity/activityDetail?id=${id}`);
                } else {
                  window.app.routerRedirect('/');
                }
              });
              return;
            }
            if (registerRoute.includes('/share/reconstitu/transit')) {
              window.app.router.goBack();
              return;
            }
            window.app.routerGoTo(registerRoute);
          } else {
            window.app.router.goBack();
          }
        } else {
          window.app.routerRedirect('/');
        }
        // const routerCount = sessionStorage.getItem('routerCount');
        // if (routerCount && routerCount > 0 && isReLogin) {
        //   window.app.router.goBack();
        // } else {
        //   window.app.routerRedirect('/');
        // }
      });
      Toast.success(t('登录成功'), 1);
      if (inletTitle) {
        window.sensors.track('userlifeCycle', {
          information_title: inletTitle,
          type: 2, // type 1,2,3,4 区分点击、登录、注册、下单
          channal: 'H5',
          userId: data.userId || '',
          cardCode: data.cardCode || ''
        });
      }
      window.sensors.track('userLoginRecord', {
        channal: 'H5',
        userId: data.userId || '',
        cardCode: data.cardCode || ''
      });
    } catch (error) {
      console.log('******', error);
    }
  });

  /**
   * getUserCount LY的
   *
   */
  getUserCount = flow(function* (params) {
    try {
      const { data = {} } = yield Serv.getUserCount(params);
      this.LYuserCount = data.userCount;
      return data;
    } catch (error) {
      console.log(error);
    }
  });

  /**
   * 手机号登录
   */
  loginByPhone = flow(function* (code, uniqueId, isLYLogin, exParams) {
    const { inletTitle = '' } = exParams || {};
    try {
      if (this.memberNum_2 === '0') this.memberNum_2 = '';
      let params = {
        phone: isLYLogin ? this.LYphone : this.phone,
        areaCode: Stores.AppMod.areaCode,
        cardCode: isLYLogin ? this.LYmemberNum_3 : this.memberNum_2,
        ...(!isLYLogin
          ? { verifyCode: code, uniqueId, loginType: 4, codeType: 2 }
          : {
              loginType: 11,
              password: rstr2b64(this.LYmemberPwd),
              rememberPasswordTag: localStorage.getItem('isRemberPwdForPho') ? 1 : 0,
              userOpenId: localStorage.getItem('openIdLYRemPwd')
            })
      };
      // 老鹰的
      if (this.LYuserCount < 2 && isLYLogin) {
        delete params.cardCode;
      }
      // 当用户手机号没绑定过任何会员卡时(或者会员号填‘0’时)，需修改与后台的交互参数
      if (!isLYLogin) {
        if (this.userCount < 2 || !this.memberNum_2) {
          delete params.cardCode;
          params.loginType = 3;
        }
      }
      if (!!sessionStorage.getItem('xm_openId') && !!sessionStorage.getItem('xm_accessToken')) {
        // 享脉参数
        params.openId = sessionStorage.getItem('xm_openId');
        params.accessToken = sessionStorage.getItem('xm_accessToken');
      }
      const { resultCode, data, resultMsg, extFields } = yield Serv.loginByPhone(params);
      if (resultCode !== '0') {
        if (resultCode == 19777 && !(sessionStorage.getItem('systemCode') == 'LY')) {
          Stores.RegisterMod.register(
            '',
            '',
            '',
            Stores.AppMod.isSmartCard,
            this.cardInfoState.code,
            {
              nickname: '',
              headimgurl: ''
            },
            3,
            extFields.registerAndLoginKey
          ).then((res) => {});
        } else {
          Toast.fail(resultMsg);
        }
        return;
      }
      sessionStorage.getItem('systemCode') == 'LY' &&
        localStorage.setItem('remberPwdForPhoNum', params.phone);
      let decoratorBackHref = localStorage.getItem('decoratorBackHref');

      const loginLastPhoneNum = utils.getLocalCache(Config.localStorageKeys.login_lastPhoneNum);

      const isReLogin = this.phone == loginLastPhoneNum;
      utils.setLocalCache(Config.localStorageKeys.login_lastPhoneNum, this.phone);
      const loginGoback = utils.getLocalCache(Config.localStorageKeys.loginGoback); // 是否返回上一个页面的标识
      const registerRoute = utils.getLocalCache(Config.localStorageKeys.registerRoute); // 返回上一页的地址
      // 用户可能在登录状态下，重新注册，所以及时清除掉以前的用户本地数据 及 应用LoginMod数据也要清除
      // LY登录
      const lyCode = sessionStorage.getItem('systemCode');
      let cacheObj = {};
      if (lyCode == 'LY') {
        cacheObj = utils.getKeysLocalCache([
          'remberPwdForAccNum',
          'isRemberPwdForAcc',
          'remberPwdForPhoNum',
          'isRemberPwdForPho'
        ]);
      }
      Stores.AppMod.clearData();
      Stores.LoginMod.clear();
      lyCode && utils.setKeysLocalCache(cacheObj);
      lyCode && sessionStorage.setItem('systemCode', lyCode);
      lyCode && sessionStorage.setItem('LYFlag', 'true');
      // 登录成功，如有会员账号，将该登录会员账号记录到本地（最近登录的6个账号）
      if (this.memberNum_2) {
        let list = JSON.parse(
          utils.getLocalCache(Config.localStorageKeys.member_recentSixNum) || '[]'
        );
        let _index = list.indexOf(this.memberNum_2);
        if (_index != -1) {
          list.splice(_index, 1);
        }
        if (list.length == 6) {
          list.shift();
        }
        list.unshift(this.memberNum_2);
        utils.setLocalCache(Config.localStorageKeys.member_recentSixNum, JSON.stringify(list));
      }
      // 保存登录信息
      Stores.AppMod.saveLoginInfo(data);

      // 存储会员信息
      Stores.AppMod.saveLoginInfo(data).then(async () => {
        const { userInfo } = Stores.AppMod;
        const { belongSystem } = userInfo || {};

        // 老鹰站点跳转提示页面
        let checkTips = await Stores.AppMod.getCheckDomainTips(belongSystem);
        if (!checkTips) return;

        if (belongSystem == 'KER') {
          Stores.AppMod.setKerUpdateHealth(); // 可儿玫瑰更新健康顾问
        }
        if (userInfo) {
          // Stores.AppMod.setImLogin({
          //   userId: userInfo.id
          // })
        }

        const { cardAttribute, cardPwdStatus, memberStatus } = userInfo || {};
        // 是否需要提示修改密码
        // if (cardAttribute == '0' && cardPwdStatus == 1 && memberStatus == '0' && !isLYLogin) {
        //   Modal.alert('温馨提示', '为了您的账户信息安全，请修改您的登录密码！', [
        //     {
        //       text: '取消',
        //       onPress: () =>window.app.routerGoTo('/shop/home')
        //     },
        //     {
        //       text: '确定',
        //       onPress: () => window.app.routerRedirect('/personal/account/alterPassword'),
        //     },
        //   ]);
        //   return;
        // }
        // const routerCount = sessionStorage.getItem('routerCount');
        // if (routerCount && routerCount > 0 && isReLogin) {
        //   window.app.router.goBack();
        // } else {
        //   window.app.routerRedirect('/');
        // }
        if (decoratorBackHref && !['null', 'undefined'].includes(decoratorBackHref)) {
          // 线下活动详情
          if (decoratorBackHref.includes('/promote/offlineActivity/activityDetail')) {
            Stores.AppMod.meetValidate(decoratorBackHref.split('id=')[1]).then((data) => {
              if (data) {
                window.app.routerRedirect(decoratorBackHref);
              } else {
                window.app.routerRedirect('/');
              }
            });
            return;
          }
          window.location.href = decoratorBackHref;
          return;
        }
        if (loginGoback) {
          utils.setLocalCache(Config.localStorageKeys.registerRoute, '');
          utils.setLocalCache(Config.localStorageKeys.loginGoback, '');
          if (registerRoute) {
            window.app.routerGoTo(registerRoute);
          } else {
            // window.app.goBack();
            window.app.router.goBack();
          }
        } else {
          window.app.routerRedirect('/');
        }
        return true;
      });
      Toast.success(t('登录成功'), 1);
      if (inletTitle) {
        window.sensors.track('userlifeCycle', {
          information_title: inletTitle,
          type: 2, // type 1,2,3,4 区分点击、登录、注册、下单
          channal: 'H5',
          userId: data.userId || '',
          cardCode: data.cardCode || ''
        });
      }
      window.sensors.track('userLoginRecord', {
        channal: 'H5',
        userId: data.userId || '',
        cardCode: data.cardCode || ''
      });
    } catch (error) {
      console.log('error>>>>', error);
    }
  });

  /**
   * 店铺登录
   */
  loginByStore = flow(async function* () {
    try {
      if (this.storeGraphUrl && !this.storeGraphCode) {
        Toast.info(t('请先输入图形验证码'));
        return;
      }
      let tmpPwd = this.storePwdStar;
      let params = {
        userName: utils.clearSpaces(this.storeNum),
        password: rstr2b64(this.storePwdStar),
        loginType: 6
        // shopUserType: this.storeLoginTarget == 0 ? '3' : '5',
      };
      console.log(params, this.storePwdStar);
      // 输错密码次数过多，需要图片验证码
      if (this.storeGraphUrl) {
        Object.assign(params, {
          verifyCode: this.storeGraphCode,
          uniqueId: this.storeGraphUniqueId,
          codeType: 1
        });
      }
      if (!!sessionStorage.getItem('xm_openId') && !!sessionStorage.getItem('xm_accessToken')) {
        // 享脉参数
        params.openId = sessionStorage.getItem('xm_openId');
        params.accessToken = sessionStorage.getItem('xm_accessToken');
      }
      const { data, resultCode, resultMsg } = yield Serv.loginByStore(params);
      if (resultCode != 0) {
        Toast.fail(resultMsg, 2);
        if ((data && data.errorType == 4) || this.storeGraphUrl) {
          this.getStoreGraphCode();
        }
        return;
      }
      // 用户可能在登录状态下，重新登录，所以及时清除掉以前的用户本地数据 及 应用LoginMod数据也要清除
      Stores.AppMod.clearData();
      Stores.LoginMod.clear();
      // 存储会员信息
      Stores.AppMod.saveLoginInfo(data).then(async () => {
        const { userInfo } = Stores.AppMod;
        const { cardAttribute, cardPwdStatus, memberStatus, belongSystem, contractSign } =
          userInfo || {};
        let checkTips = await Stores.AppMod.getCheckDomainTips(belongSystem);
        if (!checkTips) return;

        if (belongSystem == 'KER') {
          Stores.AppMod.setKerUpdateHealth(); // 可儿玫瑰更新健康顾问
        }
        if (userInfo) {
          // Stores.AppMod.setImLogin({
          //   userId: userInfo.id
          // })
        }
        // if((belongSystem == 'LD' || belongSystem == 'DD') && !contractSign){
        //   //登录成功，记录下是否是弱密码！！！
        //   if (memberPwdStar == '123456') {
        //     localStorage.setItem('isWeakPwd', 1);
        //   }
        //   return
        // }
        // 是否需要提示修改密码
        // 登录成功，记录下是否是弱密码！！！
        if (tmpPwd == '123456') {
          localStorage.setItem('isWeakPwd', 1);
          window.app.routerGoTo('store/alterPassword');
          return;
        }
        if (
          cardAttribute == '0' &&
          cardPwdStatus == 1 &&
          memberStatus == '0' &&
          memberStatus == '5'
        ) {
          // Modal.alert(
          //   '温馨提示',
          //   '为了您的账户信息安全，请修改您的登录密码！',
          //   [
          //     {
          //       text: '取消',
          //       onPress: () => window.app.routerGoTo('/shop/home'),
          //     },
          //     {
          //       text: '确定',
          //       onPress: () =>
          //         window.app.routerRedirect('/personal/account/alterPassword'),
          //     },
          //   ],
          // );
          // return;
        }
        Serv.getOpenStoreOrder().then((orderRes) => {
          let tradeNo = get(orderRes, 'data.list[0].tradeNo');
          if (tradeNo) {
            window.app.routerRedirect({
              pathname: `/member/order/detail/${tradeNo}`
            });
            return;
          }
          // 为什么要isStoreLogin? 因为userInfo和storeInfo还未回来，避免跳到店铺首页后自动跳到个人中心页
          window.app.routerRedirect({
            pathname: '/store',
            state: { isStoreLogin: true }
          });
        });
      });
      // Toast.success('登录成功', 1);
    } catch (error) {}
  });

  /**
   * 会员忘记密码 - 验证用户身份
   * @param {String} memberNum - 会员帐号
   * @param {String} realName - 姓名
   * @param {String} idCard - 证件号
   */
  verifyUser = flow(function* (memberNum, realName, idCard) {
    try {
      realName = utils.getStrictName(realName);
      if (!realName) return;
      yield Serv.confirmUser({
        cardCode: memberNum,
        realName,
        identityCard: idCard
      });
      // 验证成功，将信息存入state，重置密码需将其重新发送给后台
      this.realName = realName;
      this.idCard = idCard;
      window.app.routerGoTo({
        pathname: '/personal/account/alterPassword',
        state: {
          memberNum,
          realName,
          idCard
        }
      });
    } catch (error) {}
  });

  /**
   * 会员修改密码（忘记密码时）
   * @param {String} memberNum - 会员帐号
   * @param {String} realName - 姓名
   * @param {String} idCard - 证件号
   * @param {String} newPwd - 新密码
   * @param {String} repeatPwd - 重复新密码
   */
  alterPasswordByIdCard = flow(function* (memberNum, realName, idCard, newPwd, repeatPwd) {
    try {
      realName = utils.getStrictName(realName);
      if (!realName) return;
      let params = {
        cardCode: memberNum,
        realName,
        identityCard: idCard,
        newPassword: rstr2b64(newPwd),
        confirmPassword: rstr2b64(repeatPwd)
      };
      console.log(params);
      yield Serv.alterPasswordByIdCard(params);
      Toast.success(t('修改成功'), 1, () => {
        localStorage.removeItem('isWeakPwd');
        window.app.router.goBack(-2);
      });
    } catch (error) {}
  });

  /**
   * 手机号重置密码
   *
   * @param {String} password - 新密码
   * @param {String} passwordAgain - 重复新密码
   */
  alterPasswordByMobile = flow(function* (params) {
    console.log(params);
    try {
      let paramsS = {
        ...params,
        newPassword: rstr2b64(params.newPassword),
        confirmPassword: rstr2b64(params.confirmPassword)
      };
      console.log(params);
      yield Serv.alterPasswordByMobile(paramsS);

      // 神策数据发送
      // window.sensors.track('userInfoModify', { modifyType: '修改密码' });

      Toast.success(t('修改成功'), 1, () => {
        window.app.routerGoTo('/login');
      });
    } catch (error) {
      console.log(error);
    }
  });

  /**
   * 会员修改密码（个人中心修改密码时）
   * @param {String} originPassword - 原密码
   * @param {String} password - 新密码
   * @param {String} passwordAgain - 重复新密码
   */
  alterPasswordByAccount = flow(function* (originPassword, password, passwordAgain) {
    console.log(originPassword, password, passwordAgain);
    try {
      let params = {
        oldPassword: rstr2b64(originPassword),
        newPassword: rstr2b64(password),
        confirmPassword: rstr2b64(passwordAgain)
      };
      console.log(params);
      yield Serv.alterPasswordByAccount(params);

      // 神策数据发送
      window.sensors.track('userInfoModify', { modifyType: '修改密码' });

      Toast.success(t('修改成功'), 1, () => {
        localStorage.removeItem('isWeakPwd');
        // window.app.router.goBack();
        window.app.routerGoTo('/shop/home');
      });
    } catch (error) {}
  });

  /**
   * 店铺忘记密码 - 验证店铺身份
   * @param {String} memberNum - 会员号
   * @param {String} storeNum - 店铺编号
   * @param {String} realName - 姓名
   * @param {String} certNum - 证件号
   */
  verifyStore = flow(function* (memberNum, storeNum, realName, certNum) {
    try {
      realName = utils.getStrictName(realName);
      if (!realName) return;
      let params = {
        realName,
        cardCode: memberNum,
        userName: storeNum,
        identityCard: certNum
      };
      yield Serv.verifyStore(params);
      console.log('realName ?>?? ', realName);
      window.app.routerRedirect({
        pathname: '/store/alterPassword',
        state: {
          memberNum,
          storeNum,
          realName,
          certNum
        }
      });
    } catch (error) {}
  });

  /**
   * 店铺重置密码
   * @param {String} memberNum - 会员号
   * @param {String} storeNum - 店铺编号
   * @param {String} realName - 姓名
   * @param {String} certNum - 证件号
   * @param {String} password - 新密码
   * @param {String} passwordAgain - 重复新密码
   * @param {String} shopNo - 店铺编号
   */
  alterStorePassword = flow(
    function* (memberNum, storeNum, realName, certNum, password, passwordAgain, shopNo) {
      try {
        realName = utils.getStrictName(realName);
        if (!realName) return;
        let params = {
          realName,
          cardCode: memberNum,
          userName: storeNum,
          identityCard: certNum,
          newPassword: rstr2b64(password),
          confirmPassword: rstr2b64(passwordAgain)
        };
        shopNo && (params.userName = shopNo); // 店铺编号

        yield Serv.alterStorePassword(params);
        Toast.success(t('密码重置成功'), 1, () => {
          localStorage.removeItem('isWeakPwd');
          window.app.router.goBack();
        });
      } catch (error) {}
    }
  );

  /**
   * 店铺重置密码
   * @param {String} userType - 用户身份
   * @param {String} oldPassword - 旧密码
   * @param {String} password - 新密码
   * @param {String} shopNo - 店铺编号
   */
  alterStorePassword_2 = flow(function* (userType, oldPassword, password, shopNo) {
    try {
      let params = {
        oldPassword: rstr2b64(oldPassword),
        newPassword: rstr2b64(password),
        confirmPassword: rstr2b64(password)
      };
      shopNo && (params.userName = shopNo); // 店铺编号
      yield Serv.alterStorePassword_2(params);
      Toast.success(t('密码重置成功'), 1, () => {
        localStorage.removeItem('isWeakPwd');
        window.app.router.goBack();
      });
    } catch (error) {}
  });

  /**
   * 绑定手机号（通过卡密绑定）
   * @param {String} [openId] - 微信openId
   * @param {String} [thirdToken] - 微信token
   * @param {String} code - 验证码
   * @param {String} uniqueId - 验证码的uniqueId
   * @param {Number} phone - 手机号
   * @param {String} memberNum - 会员帐号
   * @param {String} hadEncodeMemberPwd - 会员密码（加密过的）
   */
  memberToPhoneByCard = flow(function* ({
    openId,
    thirdToken,
    code,
    uniqueId,
    phone,
    memberNum,
    hadEncodeMemberPwd
  }) {
    try {
      if (!code || !uniqueId) return;
      Toast.loading();
      let params = {
        phone,
        uniqueId,
        verifyCode: code,
        cardCode: memberNum,
        password: hadEncodeMemberPwd,
        codeType: 2,
        loginType: 1,
        type: 2,
        userDomain: Config.wxAppId || ''
      };
      if (openId && thirdToken) {
        params.openId = openId;
        params.accessToken = thirdToken;
      }
      const { data } = yield Serv.loginByMember(params);
      Stores.AppMod.saveLoginInfo(data).then(() => {
        const { userInfo } = Stores.AppMod;
        const { id: userId, cardCode } = userInfo || {};
        window.sensors.track('userLoginRecord', {
          channal: 'H5',
          userId: userId || '',
          cardCode: cardCode || ''
        });
      });
      Toast.hide();
      if (data) {
        // Stores.AppMod.setImLogin({
        //   userId: data.id
        // })
      }
      Toast.success(t('绑定成功'), 1, () => {
        window.app.routerGoTo({ pathname: '/' });
      });
    } catch (error) {}
  });

  /**
   * 更换手机号(通过会员卡密更换)
   * @param {String} code - 验证码
   * @param {String} uniqueId - 验证码的uniqueId
   * @param {Number} phone - 手机号
   * @param {String} idCard - 证件号
   * @param {String} memberNum - 会员帐号
   * @param {String} hadEncodeMemberPwd - 会员密码（加密过的）
   */
  alterPhoneByCard = flow(function* (code, uniqueId, phone, idCard, memberNum, hadEncodeMemberPwd) {
    try {
      if (!code || !uniqueId) return;
      Toast.loading();
      let params = {
        uniqueId,
        verifyCode: code,
        newPhone: phone,
        identityCard: idCard,
        cardCode: memberNum,
        password: hadEncodeMemberPwd,
        codeType: 2,
        loginType: 1,
        type: 3,
        userDomain: Config.wxAppId || ''
      };
      const { data } = yield Serv.loginByMember(params);
      Stores.AppMod.saveLoginInfo(data).then(() => {
        const { userInfo } = Stores.AppMod;
        const { id: userId, cardCode } = userInfo || {};
        window.sensors.track('userLoginRecord', {
          channal: 'H5',
          userId: userId || '',
          cardCode: cardCode || ''
        });
      });
      Toast.hide();
      Toast.success(t('更换成功'), 1, () => {
        window.app.routerGoTo('/');
      });
      return true;
    } catch (error) {}
  });

  /**
   * 绑定手机号(通过个人中心)
   * @param {Number} phone - 手机号
   * @param {String} code - 验证码
   * @param {String} uniqueId - 验证码的uniqueId
   */
  memberToPhoneByAccount = flow(function* (phone, code, uniqueId) {
    try {
      if (!code || !uniqueId) return;
      Toast.loading();
      let params = {
        phone,
        verifyCode: code,
        uniqueId
      };
      yield Serv.memberToPhoneByAccount(params);
      Stores.AppMod.getUserInfo();
      Toast.hide();
      Toast.success(t('绑定成功'), 1, () => {
        window.app.router.goBack(-1);
      });
      return true;
    } catch (error) {}
  });

  /**
   * 更换手机号(通过个人中心)
   * @param {Number} pastPhone - 旧手机号
   * @param {String} pastCode - 旧手机号对应验证码
   * @param {String} pastUniqueId - 旧手机号对应验证码的uniqueId
   * @param {Number} phone - 新手机号
   * @param {String} code - 新手机号对应验证码
   * @param {String} uniqueId - 新手机号对应验证码的uniqueId
   */
  alterPhoneByAccount = flow(
    function* (pastPhone, pastCode, pastUniqueId, phone, code, uniqueId, validType) {
      try {
        if (!code || !uniqueId) return;
        Toast.loading();
        let params = {
          phone: pastPhone,
          verifyCode: pastCode,
          uniqueId: pastUniqueId,
          newPhone: phone,
          newVerifyCode: code,
          newUniqueId: uniqueId,
          areaCode: Stores.AppMod.areaCode
        };

        if (validType === '2') {
          params = {
            phone: pastPhone,
            newPhone: phone,
            newVerifyCode: code,
            newUniqueId: uniqueId,
            areaCode: Stores.AppMod.areaCode
          };
        }

        yield Serv.alterPhoneByAccount(
          validType === '1' ? 'user/info/updatePhone' : 'user/info/updatePhone/idenityCard',
          params
        );
        Stores.AppMod.getUserInfo();
        Toast.hide();
        // 神策数据发送
        window.sensors.track('userInfoModify', { modifyType: '修改手机号' });

        Toast.success(t('更换成功'), 1, () => {
          window.app.router.goBack(-2);
        });
        return true;
      } catch (error) {}
    }
  );

  /**
   * 安全验证 - 验证手机号
   * @param {String} code - 验证码
   * @param {String} uniqueId - 验证码的uniqueId
   * @param {String} memberNum - 会员账号
   * @param {String} hadEncodeMemberPwd - 账号对应的密码（要加密过的）
   * @param {String} bindPhone - 绑定的手机号
   * @param {String} [openId] - 微信的openId
   * @param {String} [thirdToken] - 微信的token
   * @param {Boolean} [isAlterPhone] - 是否为修改手机号
   */
  verifyPhone = flow(function* ({
    code,
    uniqueId,
    memberNum,
    hadEncodeMemberPwd,
    bindPhone,
    openId,
    thirdToken,
    areaCode,
    isAlterPhone
  }) {
    try {
      if (!code || !uniqueId) return;
      let params = {
        areaCode,
        cardCode: memberNum,
        password: hadEncodeMemberPwd,
        phone: bindPhone,
        verifyCode: code,
        uniqueId,
        codeType: 2,
        loginType: 2,
        type: 1,
        appId: utils.getLocalCache('appidLY') || ''
      };
      if (openId && thirdToken) {
        params.openId = openId;
        params.accessToken = thirdToken;
      }
      const { data } = yield Serv.verifyPhone(params);
      Stores.AppMod.saveLoginInfo(data).then(() => {
        const { userInfo } = Stores.AppMod;
        const { id: userId, cardCode } = userInfo || {};
        window.sensors.track('userLoginRecord', {
          channal: 'H5',
          userId: userId || '',
          cardCode: cardCode || ''
        });
      });
      // IM登录
      // Stores.AppMod.setImLogin({
      //   userId: data.id
      // })
      Toast.success(t('验证成功'), 1, () => {
        isAlterPhone
          ? window.app.routerGoTo('/personal/account/bind/alterPhoneByCard')
          : window.app.router.replace('/');
      });
      return true;
    } catch (error) {}
  });

  /**
   * 安全验证 - 验证证件号
   * @param {String} identityCard - 证件号
   */
  checkIdentityCard = flow(function* (identityCard) {
    try {
      const result = yield Serv.checkIdentityCard({ identityCard });
      return result;
    } catch (error) {
      return error;
    }
  });

  /**
   * 会员登录按钮是否不可按
   */
  @computed get memberBtnDisable() {
    return !(this.memberNum && this.memberPwd);
  }

  /**
   * 店铺登录按钮是否不可按
   */
  @computed get storeBtnDisable() {
    return !(this.storeNum && this.storePwd);
  }

  /**
   * 微信静默登录
   */
  h5WechatLogin = flow(function* (params) {
    try {
      params = {
        ...params,
        url: `${window.location.origin}${window.location.pathname}`
      };
      const data = yield Serv.h5WechatLogin(params);
      return data;
      // }
    } catch (error) {}
  });

  /**
   * 获取第三方登录编码
   *
   */
  getThirdCode = flow(function* (params) {
    try {
      const { data, resultCode, resultMsg } = yield Serv.getThirdCode(params);
      if (+resultCode === 0) {
        return data;
      }
    } catch (error) {}
  });

  /**
   * 微信绑定会员卡
   * @param {String} openId - 微信openId
   * @param {String} thirdToken - 微信thirdToken
   * @param {String} memberNum - 会员账号
   * @param {String} memberPwd - 会员密码
   * @param {String} wxChatId - 企微id
   * @param {Object} options - 其他参数-当前用于图片验证码参数
   */
  wxToMember = flow(function* (
    openId,
    thirdToken,
    memberNum,
    memberPwd,
    unionId,
    wxChatId,
    options = {}
  ) {
    try {
      Toast.loading();
      const params = {
        openId,
        accessToken: thirdToken,
        cardCode: memberNum,
        password: rstr2b64(memberPwd),
        loginType: 1,
        type: 1,
        appId: utils.getLocalCache('appidLY') || '',
        userDomain: Config.wxAppId || '',
        ...options
      };
      if (wxChatId) {
        params.wxChatId = wxChatId;
      }
      console.log('params', params);
      const { data, resultCode, resultMsg } = yield Serv.loginByMember(params);
      Toast.hide();
      if (resultCode != 0) {
        Toast.fail(resultMsg, 2);
        if (data && data.imgVerifyFlag) {
          console.log('需要图形验证码');
          setTimeout(() => {
            yft.showImageCodeModal({
              onConfirm: (result) => {
                // 再次调用自身，并把弹窗返回的 {uniqueId, code} 传给最后一个参数 options,codeType=1图片验证码2是手机验证码
                this.wxToMember(openId, thirdToken, memberNum, memberPwd, unionId, wxChatId, {
                  ...result,
                  codeType: 1
                });
              },
              onClose: () => {
                console.log('onClose');
              }
            });
          }, 1000);
        }
        return;
      }

      // 登录成功，将该登录账号记录到本地（最近登录的6个账号）
      let list = JSON.parse(
        utils.getLocalCache(Config.localStorageKeys.member_recentSixNum) || '[]'
      );
      let _index = list.indexOf(memberNum);
      if (_index != -1) {
        list.splice(_index, 1);
      }
      if (list.length == 6) {
        list.shift();
      }
      list.unshift(memberNum);
      utils.setLocalCache(Config.localStorageKeys.member_recentSixNum, JSON.stringify(list));
      this.realName = data.realName;
      // 如果会员还未绑定手机号，立即跳转绑定手机号
      if (data.bindPhoneFlag) {
        window.app.routerGoTo({
          pathname: '/personal/account/bind/memberToPhoneByCard',
          state: {
            openId,
            thirdToken,
            bindMemberNum: memberNum,
            hadEncodeMemberPwd: rstr2b64(memberPwd)
          }
        });
        return;
      }
      // 用户一百天未登录，跳转验证身份
      if (data.phoneVerifyFlag) {
        window.app.routerGoTo({
          pathname: '/personal/account/phoneVerify',
          state: {
            openId,
            thirdToken,
            memberNum,
            hadEncodeMemberPwd: rstr2b64(memberPwd),
            bindPhone: data.phone
          }
        });
        return;
      }

      // 存储会员信息
      data &&
        Stores.AppMod.saveLoginInfo(data).then(() => {
          // 跳转产品详情页（分享的）
          const { userInfo } = Stores.AppMod;
          const { belongSystem, id: userId, cardCode } = userInfo || {};
          window.sensors.track('userLoginRecord', {
            channal: 'H5',
            userId: userId || '',
            cardCode: cardCode || ''
          });

          if (belongSystem == 'KER') {
            Stores.AppMod.setKerUpdateHealth(); // 可儿玫瑰更新健康顾问
          }

          Toast.success(t('绑定成功'), 1, () => {
            utils.gotoPage();
          });
        });
    } catch (error) {}
  });

  /**
   * Google绑定会员卡
   * @param {String} ticket - Google临时Token
   * @param {String} memberNum - 会员账号
   * @param {String} memberPwd - 会员密码
   * @param {Object} options = {} - 其他参数-当前用于图片验证码参数
   */
  googleToMember = flow(function* (ticket, memberNum, memberPwd, options = {}) {
    try {
      Toast.loading();
      const params = {
        ticket,
        cardCode: memberNum,
        password: rstr2b64(memberPwd),
        loginType: 1,
        type: 1,
        ...options
      };
      console.log('LoginMod googleToMember params', params);
      const { resultCode, resultMsg, data } = yield Serv.loginByMember(params);
      console.log('LoginMod loginByMember data', resultCode, resultMsg, data);
      Toast.hide();
      if (resultCode !== '0') {
        Toast.fail(resultMsg || '登录失败', 2);
        if (data && data.imgVerifyFlag) {
          console.log('需要图形验证码');
          setTimeout(() => {
            yft.showImageCodeModal({
              onConfirm: (result) => {
                // 再次调用自身，并把弹窗返回的 {uniqueId, code} 传给最后一个参数 options,codeType=1图片验证码2是手机验证码
                this.googleToMember(ticket, memberNum, memberPwd, {
                  ...result,
                  codeType: 1
                });
              },
              onClose: () => {
                console.log('onClose');
              }
            });
          }, 1000);
        }
        return;
      }
      // 登录成功，将该登录账号记录到本地（最近登录的6个账号）
      let list = JSON.parse(
        utils.getLocalCache(Config.localStorageKeys.member_recentSixNum) || '[]'
      );
      let _index = list.indexOf(memberNum);
      if (_index != -1) {
        list.splice(_index, 1);
      }
      if (list.length == 6) {
        list.shift();
      }
      list.unshift(memberNum);
      utils.setLocalCache(Config.localStorageKeys.member_recentSixNum, JSON.stringify(list));
      this.realName = data.realName;

      // 存储会员信息
      data &&
        Stores.AppMod.saveLoginInfo(data).then(async () => {
          const { resultCode, resultMsg } = await Serv.bindGoogle({ ticket });
          console.log('LoginMod bindGoogleResult', resultCode, resultMsg);
          if (resultCode !== '0') {
            Toast.fail(resultMsg || '绑定失败', 2);
            return;
          }
          // 跳转产品详情页（分享的）
          const { userInfo } = Stores.AppMod;
          const { belongSystem, id: userId, cardCode } = userInfo || {};
          window.sensors.track('userLoginRecord', {
            channal: 'H5',
            userId: userId || '',
            cardCode: cardCode || ''
          });

          if (belongSystem == 'KER') {
            Stores.AppMod.setKerUpdateHealth(); // 可儿玫瑰更新健康顾问
          }

          Toast.success(t('绑定成功'), 1, () => {
            utils.gotoPage();
          });
        });
    } catch (error) {}
  });

  /**
   * 微信绑定手机号
   * @param {String} openId - 微信openId
   * @param {String} thirdToken - 微信thirdToken
   * @param {Number} phone - 手机号
   * @param {String} code - 验证码
   * @param {String} uniqueId - 验证码对应的uniqueId
   * @param {String} [memberNum] - 会员账号
   * @param {String} wxChatId - 企微id
   */
  wxToPhone = flow(function* (openId, thirdToken, phone, code, uniqueId, memberNum, wxChatId) {
    try {
      Toast.loading();
      let params = {
        openId,
        accessToken: thirdToken,
        phone,
        verifyCode: code,
        uniqueId,
        loginType: 3,
        codeType: 2
      };
      // 当填写了会员号并且不为‘0’时，需修改与后台的交互参数
      if (memberNum && memberNum != '0') {
        params.cardCode = memberNum;
        params.loginType = 4;
      }
      if (wxChatId) {
        params.wxChatId = wxChatId;
      }
      const { data, resultCode, resultMsg } = yield Serv.loginByPhone(params);
      Toast.hide();
      if (resultCode != '0') {
        // 账号不存在
        Toast.fail(resultMsg);
        return;
      }

      // 登录成功，如有会员账号，将该登录会员账号记录到本地（最近登录的6个账号）
      if (memberNum) {
        let list = JSON.parse(
          utils.getLocalCache(Config.localStorageKeys.member_recentSixNum) || '[]'
        );
        let _index = list.indexOf(memberNum);
        if (_index != -1) {
          list.splice(_index, 1);
        }
        if (list.length == 6) {
          list.shift();
        }
        list.unshift(memberNum);
        utils.setLocalCache(Config.localStorageKeys.member_recentSixNum, JSON.stringify(list));
      }
      // 保存登录信息
      Stores.AppMod.saveLoginInfo(data).then(() => {
        const { userInfo } = Stores.AppMod;
        const { belongSystem, id: userId, cardCode } = userInfo || {};
        window.sensors.track('userLoginRecord', {
          channal: 'H5',
          userId: userId || '',
          cardCode: cardCode || ''
        });
        if (belongSystem == 'KER') {
          Stores.AppMod.setKerUpdateHealth(); // 可儿玫瑰更新健康顾问
        }
        if (userInfo) {
          // Stores.AppMod.setImLogin({
          //   userId: userInfo.id
          // })
        }

        Toast.success(t('绑定成功'), 1, () => {
          // 是否返回上一个页面的标识
          let loginGoback = utils.getLocalCache(Config.localStorageKeys.loginGoback);
          // 返回上一页的地址
          const registerRoute = utils.getLocalCache(Config.localStorageKeys.registerRoute);

          if (loginGoback) {
            utils.setLocalCache(Config.localStorageKeys.registerRoute, '');
            utils.setLocalCache(Config.localStorageKeys.loginGoback, '');

            if (registerRoute) {
              const isSXY = registerRoute.indexOf('learn/finding') > -1;
              if (isSXY && !!Stores.AppMod.workWechatAgentId) {
                utils.handleSXYLearning();
              } else {
                window.location.replace(`/#${registerRoute}`);
              }
            } else {
              window.location.replace(
                `${window.location.origin}${window.location.pathname}#/shop/home`
              );
            }
          } else {
            window.app.router.goBack(-3);
          }
        });
      });
      return true;
    } catch (error) {}
  });

  /**
   * 根据code获取用户微信openId、accessToken。
   * @param {String} code - 微信的code
   */
  getTokenByCode = flow(function* (code) {
    try {
      console.log('getTokenByCode request >> ', code);
      const { data } = yield Serv.getTokenByCode({
        code,
        url: `${window.location.origin}`,
        appId: Config.wxAppId || '',
        loginChannel: 4,
        loginSource: 2
      });
      console.log('getTokenByCode response >> ', data);
      const { openId, thirdToken } = data;
      return {
        openId,
        thirdToken
      };
    } catch (error) {}
  });

  /**
   * 根据openId和accessToken，获取用户头像、昵称等信息。
   * @param {String} openId - 微信openId
   * @param {String} accessToken - 微信token
   */
  getWxMsgByToken = flow(function* (openId, accessToken) {
    try {
      const { data } = yield Serv.getWxMsgByToken({ openId, accessToken });
      const { headimgurl, nickname, unionid } = data;
      return {
        avatar: headimgurl,
        nickName: nickname,
        unionId: unionid
      };
    } catch (error) {}
  });

  /**
   * 账户绑定微信(LY)
   *
   *
   */
  bindWechatLY = flow(function* (code, appid) {
    try {
      let userDomain = Config.wxAppId || '';
      yield Serv.bindWechatLY({ code, appid, channel: 'b2c_web_h5', userDomain });
      Stores.AppMod.getPersonalInfo();

      Toast.success(t('绑定成功'), 1, () => {
        utils.setLocalCache('appidLY', '');
        window.location.reload();
        // window.app.router.goBack();
      });
    } catch (error) {}
  });

  /**
   * 账户绑定微信
   * @param {String} openId - 微信openId
   * @param {String} thirdToken - 微信token
   */
  bindWechat = flow(function* (openId, thirdToken, unionId) {
    try {
      let userDomain = Config.wxAppId || '';
      yield Serv.bindWechat({ openId, thirdToken, userDomain });
      Stores.AppMod.getPersonalInfo();
      this.linkflowIdentifiers({
        externalId: Stores.AppMod.userInfo.id,
        mobilePhone: Stores.AppMod.userInfo.phone,
        weChatInfo: {
          appId: Config.wxAppId,
          openId,
          unionId
        }
      });
      Toast.success('绑定成功', 1, () => {
        window.app.router.goBack(-2);
      });
    } catch (error) {}
  });

  /**
   * 账户解绑微信(LY)
   */
  detachWechatLY = flow(function* () {
    try {
      yield Serv.detachWechatLY();
      Stores.AppMod.getPersonalInfo();
      Toast.success(t('解绑成功'), 1);
      window.location.reload();
    } catch (error) {}
  });

  /**
   * 账户解绑微信
   */
  detachWechat = flow(function* () {
    try {
      yield Serv.detachWechat();
      Stores.AppMod.getPersonalInfo().then(() => {
        Toast.success('解绑成功', 1);
      });
    } catch (error) {}
  });

  getWechatOpenid = flow(function* (code, payway, appid, platform, others) {
    try {
      let objectValue = {
        code,
        url: `${window.location.origin}`,
        appId: Config.wxAppId,
        loginChannel: 4,
        loginSource: payway ? 14 : 2,
        ...(sessionStorage.getItem('systemCode') == 'LY' && platform ? { platform } : {}),
        ...(others || {})
      };
      appid && (objectValue.appid = appid);
      const { data } = yield Serv.getWechatOpenid(objectValue);
      if (data) {
        if (payway) {
          if (payway === 'YONGYI_PAY') {
            utils.setLocalCache(Config.localStorageKeys.yy_pay_wxOpenId, data.openId);
          } else if (payway === 'WECHAT_ALLINPAY') {
            utils.setLocalCache(Config.localStorageKeys.tl_pay_wxOpenId, data.openId);
          } else if (payway === 'HUIJU_WECHAT') {
            utils.setLocalCache(Config.localStorageKeys.hj_pay_wxOpenId, data.openId);
          } else if (payway === 'HELIBAO_WECHAT') {
            utils.setLocalCache(Config.localStorageKeys.hlb_pay_wxOpenId, data.openId);
          } else if (payway === 'HUIFU_WECHAT') {
            utils.setLocalCache(Config.localStorageKeys.hf_pay_wxOpenId, data.openId);
          } else if (payway === 'LIANLIAN_WECHAT') {
            utils.setLocalCache(Config.localStorageKeys.ll_pay_wxOpenId, data.openId);
          } else if (payway === 'KUAIQIAN_WECHAT') {
            utils.setLocalCache(Config.localStorageKeys.kq_pay_wxOpenId, data.openId);
          } else if (payway === 'FUIOU_WECHAT_TWO') {
            utils.setLocalCache(Config.localStorageKeys.fu_pay_wxOpenId, data.openId);
          } else {
            utils.setLocalCache(Config.localStorageKeys.wx_pay_wxOpenId, data.openId);
          }
        } else {
          utils.setLocalCache(Config.localStorageKeys.shop_wxOpenId, data.openId);
        }
        return data.openId;
      }
    } catch (error) {}
    return '';
  });

  getYongyiPayInfo = flow(function* (params) {
    try {
      const { data } = yield Serv.getYongyiPayInfo(params);
      if (data) {
        // utils.setLocalCache(Config.localStorageKeys.yy_pay_wxOpenId, data);
        return data;
      }
    } catch (error) {}
    return '';
  });

  getWechatPayInfo = flow(function* (params) {
    try {
      const { data } = yield Serv.getWechatPayInfo(params);
      if (data) {
        // utils.setLocalCache(Config.localStorageKeys.yy_pay_wxOpenId, data);
        return data;
      }
    } catch (error) {}
    return '';
  });

  /**
   *获取汇聚支付appid
   *
   * @memberof LoginMod
   */
  getHuiJuPayInfo = flow(function* (params) {
    try {
      const { data } = yield Serv.getHuiJuPayInfo(params);
      if (data) {
        return data;
      }
    } catch (error) {}
    return '';
  });

  /**
   *获取快钱支付appid
   *
   * @memberof LoginMod
   */
  getKuaiQianInfo = flow(function* (params) {
    try {
      const { data } = yield Serv.getKuaiQianInfo(params);
      if (data) {
        return data;
      }
    } catch (error) {}
    return '';
  });

  /**
   * 获取合利宝支付appid
   */
  getHeLiBaoPayInfo = flow(function* (params) {
    try {
      const { data } = yield Serv.getHeLiBaoPayInfo(params);
      if (data) {
        return data;
      }
    } catch (error) {}
    return '';
  });

  /**
   * 获取汇付天下支付appid
   */
  getHuiFuPayInfo = flow(function* (params) {
    try {
      const { data } = yield Serv.getHuiFuPayInfo(params);
      if (data) {
        return data;
      }
    } catch (error) {}
    return '';
  });

  /**
   * 获取连连支付appid
   */
  getLianLianPayInfo = flow(function* (params) {
    try {
      const { data } = yield Serv.getLianLianPayInfo(params);
      if (data) {
        return data;
      }
    } catch (error) {}
    return '';
  });

  /**
   * 获取富友支付appid
   */
  getFuiouTwoPayInfo = flow(function* (params) {
    try {
      const { data } = yield Serv.getFuiouTwoPayInfo(params);
      if (data) {
        return data;
      }
    } catch (error) {}
    return '';
  });

  /**
   * 校验验证码
   */
  checkVerifyCode(phone, verifyCode, uniqueId, cardCode) {
    const params = {
      phone,
      verifyCode,
      uniqueId,
      ...(cardCode ? { cardCode } : {})
    };
    return Serv.checkVerifyCode(params);
  }

  getALLinPayInfo = flow(function* (params) {
    try {
      const { data } = yield Serv.getALLinPayInfo(params);
      if (data) {
        return data;
      }
    } catch (error) {}
    return '';
  });

  getLyAppId = flow(function* (params) {
    try {
      const { data, resultCode, resultMsg } = yield Serv.getWechatLoginUrl(params);
      if (+resultCode === 0) {
        return data;
      }
    } catch (error) {}
  });

  getPwdByOpenId = flow(function* (params) {
    try {
      const { data, resultCode, resultMsg } = yield Serv.getPwdByOpenId(params);
      if (+resultCode === 0) {
        return data;
      }
    } catch (error) {}
  });
  getWechatPayInfoAppId = flow(function* (params) {
    try {
      const url = `biz/tradecore/order/getWechatAppId${params && !!params.md5Sign ? '/scan' : ''}`;

      delete params.md5Sign;
      const { data } = yield Serv.getWechatPayInfoAppId(url, params);
      if (data) {
        return data;
      }
    } catch (error) {}
    return '';
  });

  /**
   * 获取图形二维码
   */
  getCaptcha = flow(function* (phone) {
    try {
      const data = yield Serv.getCaptcha(phone);
      console.log(data, 'ddddddddddddddddd');
      return null;
    } catch (error) {}
  });

  /**
   * 校验图形二维码
   */
  getImageCode = flow(function* (code, phone) {
    try {
      const data = yield Serv.getImageCode({
        imgCode: code,
        phone: phone || this.phone
      });
      return data;
    } catch (error) {}
  });

  // 解密敏感信息
  getDecyptMsg = flow(function* (params) {
    try {
      const { data } = yield Serv.getDecyptMsg(params);
      return data;
    } catch (err) {}
  });

  // 更新可儿玫瑰健康顾问
  setKerUpdateHealth = flow(function* (shareCardCode) {
    const kerData = yield Serv.setKerUpdateHealth(shareCardCode);
    return kerData;
  });

  // linkflow识别联系人
  linkflowIdentifiers = flow(function* (params) {
    yield Serv.linkflowIdentifiers(params);
  });

  getCardCodeList = flow(function* (params) {
    try {
      const { resultCode, data } = yield Serv.getCardCodeList(params);
      if (resultCode === '0' && data) {
        this.memberCardsVisible = true;
        this.memberCardList = data.map((card) => {
          return {
            card,
            checked: false
          };
        });
      }
    } catch (error) {}
  });

  checkUserPhoneCodeShowStatus = flow(function* (params) {
    try {
      const { resultCode, data } = yield Serv.checkUserPhoneCodeShowStatus(params);
      if (resultCode === '0' && data) {
        return true;
      }
      return false;
    } catch (error) {}
  });
}

const loginMod = new LoginMod();
export default loginMod;



// WEBPACK FOOTER //
// ./src/pages/Login/LoginMod.js